import { Color } from 'csstype'
import { Fragment } from 'react'
import { CidadaoListagemPessoaIdosaQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVacinasConsolidadoSection } from '../AcompanhamentoCondicaoSaudeVacinasConsolidadoSection'
import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { AcompanhamentoCondicaoSaudeIvcfAccordionPanel } from './AcompanhamentoCondicaoSaudeIvcfAccordionPanel'
import { AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel } from './AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel'

interface AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps {
  row: CidadaoListagemPessoaIdosaQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps>) {
  const pessoaIdosa = row?.pessoaIdosa

  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeVacinasConsolidadoSection vacinas={pessoaIdosa?.vacinas} iconColor={iconColor} />
      <AcompanhamentoCondicaoSaudeIvcfAccordionPanel
        riscoVulnerabilidade={row?.ivcf?.riscoVulnerabilidade}
        dataRegistro={row?.ivcf?.dataResultado}
        subgrupos={row?.ivcf?.subgrupo}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel
        quantidadeMedicoesPesoAlturaSimultaneos={pessoaIdosa?.quantidadeMedicoesSimultaneasPesoAltura}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={pessoaIdosa?.visitasDomiciliaresReportDto?.dataUltimasVisitasDomiciliares}
        qtdVisitasDomiciliares={pessoaIdosa?.visitasDomiciliaresReportDto?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </Fragment>
  )
}
